export enum SelectValueDialogType {
  Radio = 'radio',
  Checkbox = 'checkbox'
}
